import t, { createContext as l, useContext as p } from "react";
var n = l(null);
n.displayName = "OpenClosedContext";
var d = function (e) {
  return e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e;
}(d || {});
function u() {
  return p(n);
}
function s(_ref) {
  var o = _ref.value,
    r = _ref.children;
  return t.createElement(n.Provider, {
    value: o
  }, r);
}
export { s as OpenClosedProvider, d as State, u as useOpenClosed };